import { Component, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserDetailsService } from '../services/user-details.service';
import { ApiServicesService } from '../services/api-services.service';
import { HttpClientModule } from '@angular/common/http';
import { SnackbarService } from '../services/snackbar.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../envoirnments/environment';


@Component({
  selector: 'app-edit-profile',
  standalone: true,
  imports: [HttpClientModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatButtonModule, CommonModule, MatCheckbox, FontAwesomeModule, MatProgressSpinnerModule],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.css'
})
export class EditProfileComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  removeProfileimg: any;

  constructor(private fb: FormBuilder, private userdetails: UserDetailsService, public apiservices: ApiServicesService, private snackbarService: SnackbarService) {
    this.formGroup = this.fb.group({
      gender: ['', Validators.required],
      seeking: ['', Validators.required],
      month: ['', Validators.required],
      day: ['', Validators.required],
      year: ['', Validators.required],
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      seekingFor: ['', Validators.required],
      religion: ['', Validators.required],
      ethnicity: ['', Validators.required],
      maritalStatus: ['', Validators.required],
      bodyType: ['', Validators.required],
      smoker: ['', Validators.required],
      drink: ['', Validators.required],
      employment: ['', Validators.required],
      education: ['', Validators.required],
      myMatch: ['', Validators.required],
      pets: ['', Validators.required],
      children: ['', Validators.required],
      about: ['', Validators.required],
      interest: [''],
      isPrivate: [false],
    });
  }


  userData: any;
  username = '';
  dropDownData: any;
  my_gender: any;
  DOB: any;
  profilePicture: any;
  countrys: any;
  state: any;
  city: any;

  showText: boolean = true;

  ngOnInit() {
    this.removeProfileimg = 1;
    const currentYear = new Date().getFullYear();
    const yearMinus18 = currentYear - 18;

    const dropdownData = localStorage.getItem("dropdownData");
    if (!dropdownData) {
      this.apiservices.getDropdowndata().subscribe({
        next: (response: any) => {
          this.userdetails.dropDownData.next(response.data);
          localStorage.setItem("dropdownData", JSON.stringify(response.data));
        },
        error: (err) => {
          console.error('Error fetching states:', err);
        }
      });
    }else{
      const parsedData = JSON.parse(dropdownData);
      this.userdetails.dropDownData.next(parsedData);
      // console.log(' parsedData', parsedData)

    }

    this.generatedate(1, 31)
    this.generatyear(1967, yearMinus18)
    this.formGroup.get('gender')?.disable();
    this.userdetails.userdetails$.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        if (userData && userData.user) {
          this.username = this.userData.user.username;
          this.imagePreview = this.userData.thumbnail_image;
        }
      } else {
        this.userData = '';
        this.username = '';
      }
    });

    this.userdetails.dropDownData$.subscribe((dropDownData) => {
      if (dropDownData) {
        this.dropDownData = dropDownData || {};
        this.countrys = this.dropDownData.countries || [];
        this.state = this.dropDownData.states || [];
        this.city = this.dropDownData.cities || [];
        const user = this.userData.user;
        const dob = new Date(user.dob);
        // console.log('sdfghj',this.dropDownData)
        this.formGroup.patchValue({
          country: user.country?._id || '',
          seeking: user.seeking_gender?._id || '',
          state: user.state?._id || '',
          city: user.city?._id || '',
          year: dob.getFullYear(),
          month: dob.getMonth() + 1,
          day: dob.getDate(),
          seekingFor: user.seeking_for?._id || '',
          religion: user.religion?._id || '',
          ethnicity: user.ethnicity?._id || '',
          maritalStatus: user.marital_status?._id || '',
          bodyType: user.body_type?._id || '',
          smoker: user.smoking_habit?._id || '',
          drink: user.drinking_habit?._id || '',
          employment: user.employment?._id || '',
          education: user.education?._id || '',
          pets: user.pets?._id || '',
          children: user.children?._id || '',
          about: user.about,
          interest: user.interest,
          myMatch: user.my_match,
          isPrivate: user.isPrivate,
        });
        this.imagePreview = this.userData.thumbnail_image;
        // console.log('userdataaaa',this.userData)
        this.my_gender = this.userData.user.gender._id;
        const stateControl = this.formGroup.get('state');
        if (this.state.length === 0) {
          stateControl?.clearValidators(); // Remove required validation
          stateControl?.updateValueAndValidity(); // Ensure the form updates its state

          // console.log("this.states",this.state)
        }
      }
    });


  }

  onCountryChange(event: MatSelectChange): void {
    const selectedCountryId = event.value;  // Get the selected country's ID

    if (selectedCountryId) {
      this.fetchStates(selectedCountryId);
    }

    // this.formGroup.patchValue({
    //   country:'',
    // )}

    this.formGroup.patchValue({
      state: '',  // Reset the country field (if required)
      city: '',
    });
  }


  onStateChange(event: MatSelectChange): void {
    const selectedCountryId = event.value;  // Get the selected country's ID

    if (selectedCountryId) {
      this.fetchcity(selectedCountryId);
    }

    this.formGroup.patchValue({
      // Reset the country field (if required)
      city: '',
    });
  }


  fetchcity(stateId: string): void {
    const countryId1 = { stateId: stateId }
    // Call your service to fetch states based on countryId
    this.apiservices.getCItyByStates(stateId).subscribe({
      next: (citys: any) => {
        this.city = citys;  // Store the fetched states in a variable
        this.city = this.city.data;
      },
      error: (err) => {
        console.error('Error fetching states:', err);
      }
    });
  }

  fetchStates(countryId: string): void {
    this.apiservices.getStatesByCountry(countryId).subscribe({
      next: (states) => {
        const stateControl = this.formGroup.get('state');

        if (!stateControl) {
          console.error("Form control 'state' not found!");
          return;
        }

        if (!states?.data?.states || states.data.states.length === 0) {
          stateControl.clearValidators(); // Remove required validation
          stateControl.setValue(''); // Set default value to "Select"
          stateControl.updateValueAndValidity();
          this.city = states?.data?.cities || [];
          this.state = [];
        } else {
          stateControl.setValidators([Validators.required]); // Set required validation
          stateControl.setValue(''); // Keep "Select" as the default option
          stateControl.updateValueAndValidity();
          stateControl.markAsPristine(); // Fix validation error issue
          stateControl.markAsUntouched(); // Prevent immediate error display

          this.state = states?.data?.states || [];
        }
      },
      error: (err) => {
        console.error('Error fetching states:', err);
      }
    });
  }




  @Output() userDetails = new EventEmitter();
  formGroup: FormGroup;
  months: { value: number, label: string }[] = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
  ];

  faCamera = faCamera;
  daysSelect: number[] = [];
  years: number[] = [];
  selectedFileName = '';
  userProfile: any;

  baseUrl: string = 'http://localhost:4200';

  onSubmit() {
    if (this.formGroup.valid) {
      const formData = this.formGroup.value;
      this.calculateAge(formData);
      this.userDetails.emit(formData);

      this.DOB = `${this.formGroup.get('year')?.value}-${(this.formGroup.get('month')?.value).toString().padStart(2, '0')}-${(this.formGroup.get('day')?.value).toString().padStart(2, '0')}`;

      const formDataToSend = new FormData();
      if (formData.country) formDataToSend.append('country', formData.country);
      if (formData.city) formDataToSend.append('city', formData.city);
      if (formData.seeking) formDataToSend.append('seeking_gender', formData.seeking);
      // if (formData.state) {formDataToSend.append('state', formData.state);}else{formDataToSend.append('state', null);}

      formDataToSend.append('state', formData.state ? formData.state : null);
      if (this.DOB) formDataToSend.append('dob', this.DOB);
      if (formData.seekingFor) formDataToSend.append('seeking_for', formData.seekingFor);
      if (formData.religion) formDataToSend.append('religion', formData.religion);
      if (formData.ethnicity) formDataToSend.append('ethnicity', formData.ethnicity);
      if (formData.maritalStatus) formDataToSend.append('marital_status', formData.maritalStatus);
      if (formData.children) formDataToSend.append('children', formData.children);
      if (formData.bodyType) formDataToSend.append('body_type', formData.bodyType);
      if (formData.smoker) formDataToSend.append('smoking_habit', formData.smoker);
      if (formData.drink) formDataToSend.append('drinking_habit', formData.drink);
      if (formData.employment) formDataToSend.append('employment', formData.employment);
      if (formData.education) formDataToSend.append('education', formData.education);
      if (formData.myMatch) formDataToSend.append('my_match', formData.myMatch);
      if (formData.pets) formDataToSend.append('pets', formData.pets);
      if (formData.about) formDataToSend.append('about', formData.about);
      formDataToSend.append('interest', formData.interest);
      formDataToSend.append('isPrivate', formData.isPrivate ? 'true' : 'false');
      if (this.removeProfileimg == 0) formDataToSend.append('removeProfile', this.removeProfileimg);
      const fileInput = this.fileInput.nativeElement;
      if (this.profilePicture !== false) {
        if (fileInput && fileInput.files && fileInput.files.length > 0) {
          this.profilePicture = fileInput.files[0];
          formDataToSend.append('image', this.profilePicture);
        }

      } else {
        formDataToSend.append('image', this.imagePreview);

      }


      this.showText = false;
      this.apiservices.updateProfile(formDataToSend).subscribe({
        next: (response) => {
          this.showText = true;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
          this.removeProfileimg = 1;
          this.apiservices.getUserProfile(response.user.username).subscribe({
            next: (profileResponse) => {
              const encryptedData = this.apiservices.encryptData(profileResponse);
              localStorage.setItem('encryptedUserData', encryptedData);
              this.userProfile = profileResponse;
              this.userdetails.Gotuserdetails(this.userProfile);
            },
            error: (err) => {
              this.snackbarService.openCustomSnackbar(
                {
                  icon: false,
                  message: err.error.message,
                  className: 'failed',
                }
              );
            },
          });

          this.apiservices.getDropdowndata().subscribe({
            next: (response: any) => {
              this.userdetails.dropDownData.next(response.data);
              localStorage.setItem("dropdownData", JSON.stringify(response.data));
            },
            error: (err) => {
              console.error('Error fetching states:', err);
            }
          });
        },
        error: (err) => {
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        },
      });
    } else {
      this.formGroup.markAllAsTouched();
      this.scrollToFirstInvalidField();
      this.snackbarService.openCustomSnackbar(
        {
          icon: false,
          message: 'Select All Fields',
          className: 'failed',
        }
      );
    }
  }


  generatedate(start: number, end: number): void {
    for (let i = start; i <= end; i++) {
      this.daysSelect.push(i);
    }
  }
  generatyear(start: number, end: number): void {
    for (let i = start; i <= end; i++) {
      this.years.push(i);
    }
  }


  imagePreview: string = ''; // Variable to store the preview URL


  private scrollToFirstInvalidField(): void {
    const invalidControl = Object.keys(this.formGroup.controls).find((key) =>
      this.formGroup.get(key)?.invalid
    );

    if (invalidControl) {
      const element = document.getElementById(invalidControl);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0]; // Get the first file
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.result) {
          this.imagePreview = reader.result as string; // Set the preview URL
          this.removeProfileimg = 1;
        }
      };

      reader.readAsDataURL(file); // Read the file as a Data URL
    } else {
      this.imagePreview = ''; // Reset the preview if no file is selected
    }
  }

  triggerFileUpload(fileInput: HTMLInputElement): void {
    // const fileInput = document.querySelector('#fileInput') as HTMLInputElement;
    fileInput?.click();  // Programmatically trigger file input click
  }

  removeProfile() {
    // this.imagePreview = '../../assets/default-profile-img.jpg';
    this.removeProfileimg = 0;

    this.imagePreview = environment.baseUrl+'/uploads/default_avatar.png';
    this.profilePicture = '';


  }

  age!: number;

  calculateAge(formdata: any): void {

    const birthDate = new Date(formdata.year, formdata.month - 1, formdata.day); // Months are 0-indexed in JS Date.
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthDate.getMonth();

    // If the current month is before the birth month, or it's the same month but the current day is before the birth day, subtract one year from age
    if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
      age--;
    }
    this.age = age;
  }


}
